import { Navigate, Route, Routes } from 'react-router-dom';
import { FC, Suspense } from 'react';
import Layout from 'components/Base/Layout';
import { appRoutes, LandingResolver } from './RoutesData';
import { RoutesPaths } from './Routes.types';

const PublicRoutes: FC = () => {
  return (
    <Suspense fallback={<Layout />}>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<LandingResolver />} />
          {appRoutes.map(({ path, component }) => {
            const Component = component;
            return <Route key={path} path={path} element={<Component />} />;
          })}
          <Route
            path="*"
            element={<Navigate to={RoutesPaths.PAGE_NOT_FOUND} />}
          />
        </Route>
      </Routes>
    </Suspense>
  );
};

export default PublicRoutes;
